export default ["#1D3659","#4B5E78","#7B8798","#AAB0B9", "#D9D9D9","#F16568","#6bd583"]

export const newColors = ["#000000","#FFFFFF","#588B8B","#1C3557","#FF8811","#E9E9E9"]